import alertify from 'alertify';

export function initBim(viewToken, elementId = 'item-3d-display') {
  if (!viewToken) return false;

  // 初始化显示组件
  var options = new BimfaceSDKLoaderConfig();
  options.viewToken = viewToken;
  BimfaceSDKLoader.load(options, successCallback, failureCallback);

  function successCallback(viewMetaData) {
    // 创建WebApplication，直接显示模型或图纸
    var dom4Show = document.getElementById(elementId);
    new Glodon.Bimface.Application.WebApplicationDemo(viewMetaData, dom4Show);
  }

  function failureCallback(error) {
    console.log(error);
  };

  return true;
}


// WEBPACK FOOTER //
// ./src/logic/bim.js